
 export const BaseURL = `https://point-back.point-dev.net/api/`;
export const ImageBaseURL = `https://point-back.point-dev.net `;
// export const BaseURL = `http://127.0.0.1:8000/api/`;
// export const ImageBaseURL = `http://127.0.0.1:8000`;

const PROJECT_NAME = "Point"

export const TOKEN_KEY = PROJECT_NAME +  "_TOKEN"

export const USER_KEY =  PROJECT_NAME + "_USER"

